let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3oiFV")).then(() => parcelRequire('bM3Ak'));